import React from 'react';
import { Heart, Music, Activity, Mic, BookOpen } from 'lucide-react';
export function ParentGuide() {
  return <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-456">
      <div className="text-center mb-16" data-id="element-457">
        <h2 className="text-4xl font-bold text-gray-900 mb-6" data-id="element-458">家长指南</h2>
        <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-459">
          如何使用古诗音乐实验室，帮助孩子开启音乐启蒙之旅
        </p>
      </div>

      {/* Philosophy Section */}
      <div className="bg-white rounded-3xl p-8 shadow-lg mb-12 border-l-8 border-[#C41E3A]" data-id="element-460">
        <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-461">
          <Heart className="w-8 h-8 text-[#C41E3A] mr-3" data-id="element-462" />
          我们的教育理念
        </h3>
        <div className="grid md:grid-cols-2 gap-8" data-id="element-463">
          <div data-id="element-464">
            <h4 className="font-bold text-lg mb-2" data-id="element-465">
              参与感 (Active Participation)
            </h4>
            <p className="text-gray-600 leading-relaxed" data-id="element-466">
              孩子不是被动的听众，而是音乐的创造者。通过点击、触摸、律动，让孩子全身心投入到音乐体验中。
            </p>
          </div>
          <div data-id="element-467">
            <h4 className="font-bold text-lg mb-2" data-id="element-468">身体记忆 (Body Memory)</h4>
            <p className="text-gray-600 leading-relaxed" data-id="element-469">
              节奏感不仅在耳朵里，更在身体里。通过拍手、跺脚等动作，让孩子用身体感受韵律，记忆更深刻。
            </p>
          </div>
        </div>
      </div>

      {/* Steps */}
      <div className="space-y-8 mb-16" data-id="element-470">
        <h3 className="text-2xl font-bold text-gray-900 text-center mb-8" data-id="element-471">
          循序渐进的学习路径
        </h3>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-472">
          <div className="bg-purple-50 rounded-2xl p-6" data-id="element-473">
            <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mb-4 text-purple-600 font-bold text-xl" data-id="element-474">
              1
            </div>
            <h4 className="text-xl font-bold text-purple-900 mb-2" data-id="element-475">
              聆听与感受
            </h4>
            <p className="text-purple-700" data-id="element-476">
              使用"聆听感受"模块，让孩子先熟悉古诗的旋律和意境。不要急着解释意思，先感受美。
            </p>
          </div>

          <div className="bg-orange-50 rounded-2xl p-6" data-id="element-477">
            <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mb-4 text-orange-600 font-bold text-xl" data-id="element-478">
              2
            </div>
            <h4 className="text-xl font-bold text-orange-900 mb-2" data-id="element-479">
              节拍与律动
            </h4>
            <p className="text-orange-700" data-id="element-480">
              进入"节拍律动"模块，跟随节奏做动作。这是培养节奏感的关键步骤，鼓励孩子大胆动起来。
            </p>
          </div>

          <div className="bg-blue-50 rounded-2xl p-6" data-id="element-481">
            <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-4 text-blue-600 font-bold text-xl" data-id="element-482">
              3
            </div>
            <h4 className="text-xl font-bold text-blue-900 mb-2" data-id="element-483">创造与表达</h4>
            <p className="text-blue-700" data-id="element-484">
              通过"音阶探索"让孩子自由演奏。五声调式怎么弹都好听，建立孩子的自信心。
            </p>
          </div>
        </div>
      </div>

      {/* FAQ */}
      <div className="bg-gray-50 rounded-3xl p-8" data-id="element-485">
        <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-486">常见问题</h3>
        <div className="space-y-6" data-id="element-487">
          <div data-id="element-488">
            <h4 className="font-bold text-gray-900 mb-2" data-id="element-489">孩子多大适合使用？</h4>
            <p className="text-gray-600" data-id="element-490">
              本产品设计适合4-10岁的儿童。4-6岁建议家长陪同，7岁以上可以独立探索。
            </p>
          </div>
          <div data-id="element-491">
            <h4 className="font-bold text-gray-900 mb-2" data-id="element-492">为什么只有五个音？</h4>
            <p className="text-gray-600" data-id="element-493">
              中国传统音乐主要使用五声调式（宫商角徵羽），这不仅是文化传承，也因为五声音阶和谐悦耳，非常适合儿童启蒙，怎么弹都不会"跑调"。
            </p>
          </div>
        </div>
      </div>
    </div>;
}